export default __webpack_public_path__ + "static/media/hht1_ep06_timeline_q05_b.6afbb3f1.png";